/* eslint-disable @typescript-eslint/no-explicit-any */
import { handleErrorDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React from 'react';
export function showJsonEditorDialog(params) {
    showCustomDialog({
        maxWidth: 'lg',
        fullWidth: true,
        content: (close) => (React.createElement(JsonEditorDialogContent, { params: params, onCancel: close, onSave: (json) => {
                close(() => params.onSave(json));
            } })),
    });
}
const JsonEditorDialogContent = (props) => {
    const [value, setValue] = React.useState(() => JSON.stringify(props.params.json, undefined, '  '));
    const [validating, setValidating] = React.useState(false);
    let json = undefined;
    let parseError = undefined;
    try {
        json = JSON.parse(value);
    }
    catch (e) {
        parseError = e;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, props.params.title),
        React.createElement(DialogContent, null,
            React.createElement(TextField, { variant: 'outlined', multiline: true, rows: 20, fullWidth: true, sx: { mt: 1 }, inputProps: { style: { fontFamily: 'monospace' } }, label: 'JSON', error: parseError != null, helperText: parseError != null ? parseError.toString() : 'JSON is valid', disabled: validating, value: value, onChange: (event) => setValue(event.target.value) })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', disabled: validating, onClick: () => props.onCancel() }, "Cancel"),
            React.createElement(Button, { color: 'primary', disabled: validating, onClick: () => {
                    if (json !== undefined) {
                        if (props.params.onValidate) {
                            setValidating(true);
                            props.params
                                .onValidate(JSON.parse(value))
                                .then((result) => props.onSave(result))
                                .catch((error) => {
                                handleErrorDialog(error);
                                setValidating(false);
                            });
                        }
                        else {
                            props.onSave(json);
                        }
                    }
                } }, "OK"))));
};
